import { deserialize } from 'cerialize'

export class OrganizationModel {
	@deserialize public id: number
	@deserialize public is_ors: boolean
	@deserialize public is_rr: boolean
	@deserialize public inn: string
	@deserialize public name: string
	@deserialize public phone: string | null
	@deserialize public status: string
	@deserialize public registered_at: string | null
	@deserialize public external_id: string | null
	@deserialize public created_by_user: {
		id: number
		name: string
	}
}
